// extracted by mini-css-extract-plugin
export default {"LoadWrapper":"load_LoadWrapper__L3mrA","Load":"load_Load__MG8uN","LoadMessage":"load_LoadMessage__KiFRS","load-rotate":"load_load-rotate__OIDdY"};